import React, { ReactNode, useEffect, useState } from 'react';
import { Box, styled } from '@withjoy/joykit';

const TRANSITION_MS = 180;
const OVERLAP_MS = 80;

const SlideBox = styled(Box)<{ $expanded: boolean; $visible: boolean }>`
  max-width: ${({ $expanded }) => ($expanded ? '40px' : '0px')};
  height: 100%;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition:
    max-width ${TRANSITION_MS}ms ease,
    opacity ${TRANSITION_MS}ms ease;
  transition-delay: ${({ $expanded }) => ($expanded ? `0s, ${TRANSITION_MS / 1000}s` : '0s, 0s')};
  overflow: hidden;
  margin: auto 0;
`;

type SlideWrapperProps = {
  show: boolean;
  children?: ReactNode;
};

export const SlideWrapper = (props: SlideWrapperProps) => {
  const { show, children } = props;
  const [expanded, setExpanded] = useState(show);
  const [visible, setVisible] = useState(show);

  useEffect(() => {
    if (show) {
      setExpanded(true);
      const timeout = setTimeout(() => setVisible(true), TRANSITION_MS - OVERLAP_MS);
      return () => clearTimeout(timeout);
    } else {
      setVisible(false);
      const timeout = setTimeout(() => setExpanded(false), TRANSITION_MS - OVERLAP_MS);
      return () => clearTimeout(timeout);
    }
  }, [show]);

  return (
    <SlideBox
      $expanded={expanded}
      $visible={visible}
    >
      {children}
    </SlideBox>
  );
};
